import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Spinner } from '@/shared/components/Spinner';
import { EmptyState } from '@/shared/components/EmptyState';
import { Badge } from '@/shared/components/Badge';
import { Button } from '@/shared/components/Button';
import { formatDate } from '@/shared/utils/format';
import { useStudentInvitations, useResendStudentInvitation, useCancelStudentInvitation, } from '../hooks/useStudentInvitations';
const statusVariant = {
    pending: 'warning',
    accepted: 'success',
    expired: 'default',
    cancelled: 'danger',
};
const statusLabel = {
    pending: 'Pendiente',
    accepted: 'Aceptada',
    expired: 'Caducada',
    cancelled: 'Cancelada',
};
export function InvitationsListPanel() {
    const { data: invitations = [], isLoading, isError } = useStudentInvitations();
    const resend = useResendStudentInvitation();
    const cancel = useCancelStudentInvitation();
    const [busyId, setBusyId] = useState(null);
    const [feedback, setFeedback] = useState(null);
    function handleResend(id) {
        setBusyId(id);
        setFeedback(null);
        resend.mutate(id, {
            onSuccess: () => setFeedback('Invitación reenviada.'),
            onError: () => setFeedback('No se pudo reenviar la invitación.'),
            onSettled: () => setBusyId(null),
        });
    }
    function handleCancel(id) {
        if (!window.confirm('¿Cancelar esta invitación? Ya no se podrá usar el enlace.'))
            return;
        setBusyId(id);
        setFeedback(null);
        cancel.mutate(id, {
            onSuccess: () => setFeedback('Invitación cancelada.'),
            onError: () => setFeedback('No se pudo cancelar la invitación.'),
            onSettled: () => setBusyId(null),
        });
    }
    if (isLoading) {
        return (_jsx("div", { className: "flex h-32 items-center justify-center", children: _jsx(Spinner, {}) }));
    }
    if (isError) {
        return _jsx("p", { className: "text-sm text-red-600", children: "No se pudieron cargar las invitaciones." });
    }
    if (invitations.length === 0) {
        return _jsx(EmptyState, { title: "Sin invitaciones", description: "A\u00FAn no has enviado ninguna invitaci\u00F3n a alumnos." });
    }
    return (_jsxs("div", { className: "space-y-3", children: [feedback && (_jsx("div", { className: "rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700 dark:border-blue-400/40 dark:bg-blue-500/10 dark:text-blue-200", children: feedback })), _jsx("div", { className: "overflow-x-auto -mx-2 sm:mx-0", children: _jsxs("table", { className: "min-w-full text-sm", children: [_jsx("thead", { className: "text-[11px] uppercase tracking-wider text-gray-500 dark:text-gray-400", children: _jsxs("tr", { children: [_jsx(Th, { children: "Email" }), _jsx(Th, { children: "Oposici\u00F3n" }), _jsx(Th, { children: "Estado" }), _jsx(Th, { children: "Caduca" }), _jsx(Th, { children: "Env\u00EDos" }), _jsx(Th, { children: "Creada" }), _jsx(Th, {})] }) }), _jsx("tbody", { className: "divide-y divide-gray-100 dark:divide-gray-800", children: invitations.map((inv) => (_jsxs("tr", { className: "hover:bg-gray-50 dark:hover:bg-gray-800/40", children: [_jsx(Td, { className: "font-mono", children: inv.email }), _jsx(Td, { children: inv.opposition_name }), _jsx(Td, { children: _jsx(Badge, { variant: statusVariant[inv.status], children: statusLabel[inv.status] }) }), _jsx(Td, { children: formatDate(inv.expires_at) }), _jsx(Td, { className: "tabular-nums", children: inv.send_count }), _jsx(Td, { className: "text-gray-500 dark:text-gray-400", children: formatDate(inv.created_at) }), _jsx(Td, { children: inv.status === 'pending' && (_jsxs("div", { className: "flex gap-1 justify-end", children: [_jsx(Button, { size: "sm", variant: "ghost", loading: busyId === inv.id && resend.isPending, disabled: busyId === inv.id, onClick: () => handleResend(inv.id), children: "Reenviar" }), _jsx(Button, { size: "sm", variant: "ghost", loading: busyId === inv.id && cancel.isPending, disabled: busyId === inv.id, onClick: () => handleCancel(inv.id), children: "Cancelar" })] })) })] }, inv.id))) })] }) })] }));
}
function Th({ children }) {
    return _jsx("th", { className: "text-left font-semibold py-2 px-3", children: children });
}
function Td({ children, className = '' }) {
    return _jsx("td", { className: `py-2 px-3 align-middle ${className}`, children: children });
}
//# sourceMappingURL=InvitationsListPanel.js.map